import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { Button, Checkbox, Input, message, Popconfirm, Space, Table } from "antd";
import { renderCheckbox, renderDateTime, renderNumber } from "@extensions/helper";
import { softVidsRender } from "@extensions/enums";
import { refreshButton } from "@extensions/design";
import CompanyBase from "./company-base";

const CompanyBases = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ showDelete: false });
  const [searchStr, setSearchStr] = useState('');
  const [selected, setSelected] = useState();
  const [selectedIds, setSelectedIds] = useState([]);

  const getData = () => {
    setLoading(true);
    serverFetch(`db?showDeleted=${filter.showDelete}`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [filter]);

  const columns = [
    { dataIndex: "id", title: "#" },
    { dataIndex: "isDel", title: "Удалена", render: renderCheckbox },
    { dataIndex: "name", title: "Наименование" },
    { dataIndex: "guid", title: "Код" },
    { dataIndex: "nstrVer", title: "Настройки", render: renderNumber },
    { dataIndex: "datetimeReg", title: "Регистрация", render: renderDateTime },
  ]

  const filtered = items.filter(i => {
    if (!searchStr) return true;
    if (i.name.toLowerCase().includes(searchStr.toLowerCase())) return true;
    return false;
  })

  const onFilterChange = value => setFilter({ ...filter, ...value });
  const onCloseEdit = refresh => {
    setSelected();
    refresh && getData();
  }

  const handleDelete = () => {
    if (!selectedIds.length) return;
    
    setLoading(true);
    serverFetch("db", { method: "DELETE", bodyData: selectedIds })
      .then(() => {
        message.success("Базы удалены");
        setSelectedIds([]);
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка при удалении");
      });
  };

  return <div>
    <Space>
      <Checkbox checked={filter.showDelete} onChange={e => onFilterChange({ showDelete: e.target.checked})}>Показать удаленные</Checkbox>
      <Input placeholder="Поиск" value={searchStr} onChange={e => setSearchStr(e.target.value)}/>
      {refreshButton(getData)}
      <Popconfirm 
        title="Подтверждение удаления" 
        description={`Вы уверены, что хотите удалить ${selectedIds.length} баз(у)?`}
        onConfirm={handleDelete}
        okText="Удалить"
        cancelText="Отмена"
        disabled={!selectedIds.length}
      >
        <Button danger disabled={!selectedIds.length || loading}>Удалить</Button>
      </Popconfirm>
    </Space>
    <Table 
      dataSource={filtered}
      loading={loading}
      columns={columns}
      pagination={false}
      size="small"
      rowKey="id"
      rowSelection={{ 
        type: 'checkbox', 
        selectedRowKeys: selectedIds, 
        onChange: (selectedRowKeys) => setSelectedIds(selectedRowKeys),
        renderCell: (checked, record, index, node) => node
      }}
      onRow={(record) => ({
        onClick: (e) => {
          // Не выбирать для редактирования если кликнули на чекбокс
          if (e.target.type !== 'checkbox' && e.target.closest('.ant-checkbox') === null) {
            setSelected(record.id);
          }
        }
      })}
      />
    {selected && <CompanyBase onClose={onCloseEdit} id={selected} />}
  </div>
}

export default CompanyBases;